import { SvgIconProps } from '@traba/types'

export default function Check({
  size,
  color,
  strokeWidth,
  ...rest
}: SvgIconProps) {
  return (
    <svg viewBox="0 0 15 12" width={size} height={size} fill="none" {...rest}>
      <path
        d="M13.5 1L4.92857 11L1.5 7"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
